'use strict';

function cnFile() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      fileChange: '&'
    },
    link: function link(scope, element, attrs, ctrl) {
      element.on('change', onChange);

      scope.$on('destroy', function () {
        element.off('change', onChange);
      });

      function onChange() {
        ctrl.$setViewValue(attrs.multiple ? element[0].files : element[0].files[0]);
        scope.$apply(function () {
          scope.fileChange();
        });
      }
    }
  };
}

module.exports = cnFile;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/directives/file/index.js
 ** module id = 21
 ** module chunks = 0
 **/